module cr.events
{
    class xcoService {
        endpoint:string = "https://prod.chronorace.be/api/";
        //endpoint:string = "/api/";

        static $inject = ['$http','cfg'];

        constructor(private $http,cfg) {
            if (angular.isDefined(cfg.EventApiUrl))
            {
                this.endpoint=cfg.EventApiUrl;
            }

            console.log("xco service endpoint: "+this.endpoint);
        }

        raceList(db:string): angular.IPromise<any> {
            return this.$http.jsonp(this.endpoint+'results/xco/'+db+'/race-list?callback=JSON_CALLBACK')
                .then((result) => {
                    console.log("return: "+result.data);
                   return result.data;
                });
        }

        overview(db:string,raceName:string): angular.IPromise<any> {
            return this.$http.jsonp(this.endpoint+'results/xco/'+db+'/overview/'+raceName+'?callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

        registration(db:string,raceName:string): angular.IPromise<any> {
            return this.$http.jsonp(this.endpoint+'results/xco/'+db+'/registration/'+raceName+'?callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

    }
    eventModule.service('xcoService', xcoService);
}
